import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from '../context/User';
import DeckCalculator from './DeckCalculator';
import PorchCalculator from './PorchCalculator';
import GarageCalculator from './GarageCalculator';
import CarportCalculator from './CarportCalculator';
import { Spinner } from '../Spinner.js';
import './Calculator.css';
import CalculatorService from '../../services/CalculatorService.ts';
import { CalcsContext } from '../context/Calcs.js';

const Calculator = ({ activeCalculator, calcObj, itemObj }) => {
  const calcService = new CalculatorService();
  const [loading, setLoading] = useState(true);
  const { user } = useContext(UserContext);
  const { calcMap, itemMap, setItemMap } = useContext(CalcsContext);

  useEffect(() => {
    if (calcObj && itemObj) {
      setLoading(false);
    }
  }, [calcObj, itemObj, setItemMap]);

  function handleSubmit(obj, itemMap) {
    return calcService.calculate(obj, JSON.parse(JSON.stringify(itemMap)));
  }

  const renderCalculator = () => {
    if(calcMap && itemMap) {
      switch (activeCalculator) {
        case 'deck':
          return <DeckCalculator deckObj={calcMap?.deck}
            deckMap={itemMap?.deck}
            isAdmin={user && !user.isAnonymous && user.emailVerified}
            handleSubmit={handleSubmit}
          />;
        case 'porch':
          return <PorchCalculator porchObj={calcMap?.porch}
            porchMap={itemMap?.porch}
            isAdmin={user && !user.isAnonymous && user.emailVerified}
            handleSubmit={handleSubmit}
          />;
        case 'garage':
          return <GarageCalculator garageObj={calcMap?.garage}
            garageMap={itemMap?.garage}
            isAdmin={user && !user.isAnonymous && user.emailVerified}
            handleSubmit={handleSubmit}
          />;
        case 'carport':
          return <CarportCalculator carportObj={calcMap?.carport}
            carportMap={itemMap?.carport}
            isAdmin={user && !user.isAnonymous && user.emailVerified}
            handleSubmit={handleSubmit}
          />;
        default:
          return null;
      }
    }
  };

  return (
    <div className="calculator-container">
      <div className="calculator-content" id='container'>
        {renderCalculator()}
      </div>
      {loading &&
        <Spinner isLoading={loading}></Spinner>
      }
    </div>
  );
};

export default Calculator;